import { ModuleFE_FocusedObject } from './ModuleFE_FocusedObject.js';
export const ModulePack_FocusedObjectFE = [
    ModuleFE_FocusedObject
];
export const ModulePackFE_FocusedObject = ModulePack_FocusedObjectFE;
//# sourceMappingURL=module-pack.js.map